import { useEffect, useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Footer } from './Footer'
import { Header } from './Header'
import styles from './SiteLayout.module.css'

/** The top-level segment of a path, e.g. `/projects/scara` -> `projects`. */
function section(pathname: string): string {
  return pathname.split('/')[1] ?? ''
}

/**
 * Scrolls to the top when the visitor moves to a different part of the site,
 * but not when a project modal opens over the grid it came from.
 */
function useScrollToTopOnSectionChange() {
  const { pathname } = useLocation()
  const previous = useRef(section(pathname))

  useEffect(() => {
    const current = section(pathname)
    if (current !== previous.current) {
      window.scrollTo({ top: 0 })
      previous.current = current
    }
  }, [pathname])
}

export function SiteLayout() {
  useScrollToTopOnSectionChange()

  return (
    <div className={styles.shell}>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Header />
      <main id="main" className={styles.main} tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
